import request from '@/utils/request'
export const apiAiAssistantAsinAbaListPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/abaList`, method: 'post', data })
}
export const apiAiAssistantAsinAdvertisingListPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/advertisingList`, method: 'post', data })
}
export const apiAiAssistantAsinAsinDetailPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/asinDetail`, method: 'post', data })
}
export const apiAiAssistantAsinCompetitorListPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/competitorList`, method: 'post', data })
}
export const apiAiAssistantAsinExportSourcePost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/exportSource`, method: 'post', data })
}
export const apiAiAssistantAsinGetAbaFromSellerSpriteGet = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/getAbaFromSellerSprite`, method: 'get' })
}
export const apiAiAssistantAsinGetAiImproveAdGet = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/getAiImproveAD`, method: 'get' })
}
export const apiAiAssistantAsinGetKeywordFromSifGet = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/getKeywordFromSif`, method: 'get' })
}
export const apiAiAssistantAsinGetMainMessFromRpaGet = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/getMainMessFromRpa`, method: 'get' })
}
export const apiAiAssistantAsinGoogleListPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/googleList`, method: 'post', data })
}
export const apiAiAssistantAsinListPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/list`, method: 'post', data })
}
export const apiAiAssistantAsinPostAiImprovedPlanDeepseek1Get = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAiImprovedPlanDeepseek1`, method: 'get' })
}
export const apiAiAssistantAsinPostAiImprovedPlanDeepseek2Get = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAiImprovedPlanDeepseek2`, method: 'get' })
}
export const apiAiAssistantAsinPostAiImprovedPlanGpt1Get = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAiImprovedPlanGpt1`, method: 'get' })
}
export const apiAiAssistantAsinPostAiImprovedPlanGpt2Get = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAiImprovedPlanGpt2`, method: 'get' })
}
export const apiAiAssistantAsinPostAiImprovedSuggestGptGet = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAiImprovedSuggestGpt`, method: 'get' })
}
export const apiAiAssistantAsinPostAiImprovedSuggestQwenGet = () => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAiImprovedSuggestQwen`, method: 'get' })
}
export const apiAiAssistantAsinPostAsinsPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/postAsins`, method: 'post', data })
}
export const apiAiAssistantAsinSaveAsinPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/saveAsin`, method: 'post', data })
}
export const apiAiAssistantAsinSaveImprovePlanScopePost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/saveImprovePlanScope`, method: 'post', data })
}
export const apiAiAssistantAsinSelectImprovePlanPost = data => {
  return request({ url: `/hhxc-business/api/aiAssistant/asin/selectImprovePlan`, method: 'post', data })
}
export const apiSpiderGetHostListGet = params => {
  return request({ url: `/hhxc-business/api/spider/get-host-list`, method: 'get', params })
}
export const apiSpiderGetHostTasksPost = data => {
  return request({ url: `/hhxc-business/api/spider/get-host-tasks`, method: 'post', data })
}
export const apiSpiderSubmitTaskPost = data => {
  return request({ url: `/hhxc-business/api/spider/submit-task`, method: 'post', data })
}
export const apiV1AkListingSalesAsinSalesPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/akListingSales/asinSalesPage`, method: 'post', data })
}
export const apiV1AkListingSalesAsinSalesReportPost = data => {
  return request({ url: `/hhxc-business/api/v1/akListingSales/asinSalesReport`, method: 'post', data })
}
export const apiV1AkListingSalesProductSalesPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/akListingSales/productSalesPage`, method: 'post', data })
}
export const apiV1AkListingSalesProductSalesReportPost = data => {
  return request({ url: `/hhxc-business/api/v1/akListingSales/productSalesReport`, method: 'post', data })
}
export const apiV1BusinessAdQuerywordsListAddDtoPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/ListAddDTO`, method: 'post', params })
}
export const apiV1BusinessAdQuerywordsProductOneVoListPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/ProductOneVOList`, method: 'post', params })
}
export const apiV1BusinessAdQuerywordsProductSbvoListPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/ProductSBVOList`, method: 'post', params })
}
export const apiV1BusinessAdQuerywordsProductVoListPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/ProductVOList`, method: 'post', params })
}
export const apiV1BusinessAdQuerywordsQueryWordsOnePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/QueryWordsOne`, method: 'post' })
}
export const apiV1BusinessAdQuerywordsSbQueryWordDetailPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/SBQueryWordDetail`, method: 'post', data })
}
export const apiV1BusinessAdQuerywordsSBqueryListPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/SBqueryList`, method: 'post', params })
}
export const apiV1BusinessAdQuerywordsSBqueryMaxListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/SBqueryMaxList`, method: 'post', data })
}
export const apiV1BusinessAdQuerywordsSpQueryWordDetailPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/SPQueryWordDetail`, method: 'post', data })
}
export const apiV1BusinessAdQuerywordsSPqueryListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/SPqueryList`, method: 'post', data })
}
export const apiV1BusinessAdQuerywordsSPqueryMaxListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/SPqueryMaxList`, method: 'post', data })
}
export const apiV1BusinessAdQuerywordsParPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdQuerywords/par`, method: 'post', params })
}
export const apiV1BusinessAdReportGroupreportSdpVoGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdReportGroupreport/SdpVO`, method: 'get', params })
}
export const apiV1BusinessAdReportGroupreportDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAdReportGroupreport/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessAdReportGroupreportGroupReportOnePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAdReportGroupreport/groupReportOne`, method: 'post' })
}
export const apiV1BusinessAdTargetingReportTargetingReportOnePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAdTargetingReport/TargetingReportOne`, method: 'post' })
}
export const apiV1BusinessAkcampaignReportSdpVoGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaignReport/SdpVO`, method: 'get', params })
}
export const apiV1BusinessAkcampaignReportAdGroupsTypeGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaignReport/adGroupsType`, method: 'get' })
}
export const apiV1BusinessAkcampaignReportCampaignReportPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaignReport/campaignReport`, method: 'post' })
}
export const apiV1BusinessAkcampaignReportCampaignsTypeGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaignReport/campaignsType`, method: 'get' })
}
export const apiV1BusinessAkcampaignReportDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaignReport/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessAkcampaignReportProductsTypeGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaignReport/productsType`, method: 'get' })
}
export const apiV1BusinessAkcampaignsSellerSbGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaigns/SellerSB`, method: 'get' })
}
export const apiV1BusinessAkcampaignsDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaigns/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessAkcampaignsSbvoListGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkcampaigns/sbvoList`, method: 'get', params })
}
export const apiV1BusinessAkproductReportAdDailyOrderVoListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdDailyOrderVOList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportAdOrderWeekListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdOrderWeekList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportAdProductReportAnalysisVoListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdProductReportAnalysisVOList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportAdProjectNameVoListPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdProjectNameVOList`, method: 'post', params })
}
export const apiV1BusinessAkproductReportAdTrendListDownloadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdTrendListDownload`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessAkproductReportAdWeekListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdWeekList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportAdtrendListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AdtrendList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportAsinNameDtoListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AsinNameDTOList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportAuthDtOlistGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/AuthDTOlist`, method: 'get', params })
}
export const apiV1BusinessAkproductReportPreparerListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/PreparerList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportBrandNameGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/brandName`, method: 'get', params })
}
export const apiV1BusinessAkproductReportDownloadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/download`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessAkproductReportListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/list`, method: 'post', data })
}
export const apiV1BusinessAkproductReportList1Get = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/list1`, method: 'get', params })
}
export const apiV1BusinessAkproductReportProductReportPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/productReport`, method: 'post' })
}
export const apiV1BusinessAkproductReportProductReportParentAsinVoListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/productReportParentAsinVOList`, method: 'post', data })
}
export const apiV1BusinessAkproductReportProductReportParentAsinVoListDelitPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/productReportParentAsinVOListDelit`, method: 'post', data })
}
export const apiV1BusinessAkproductReportProductReportParentAsinVoListDownloadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAkproductReport/productReportParentAsinVOListDownload`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessAkproductsReportVOlistGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkproducts/ReportVOlist`, method: 'get', params })
}
export const apiV1BusinessAkproductsDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAkproducts/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessAkproductsProductsPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAkproducts/products`, method: 'post' })
}
export const apiV1BusinessAsinLogAdAsinLogPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/ADAsinLog`, method: 'post', data })
}
export const apiV1BusinessAsinLogAsinLogAddPost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/AsinLogAdd`, method: 'post', params, data })
}
export const apiV1BusinessAsinLogAsinLogListGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/AsinLogList`, method: 'get', params })
}
export const apiV1BusinessAsinLogAsinLogRemoveIdIdsDelete = (ids, params) => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/AsinLogRemoveId/${ids}`, method: 'delete', params })
}
export const apiV1BusinessAsinLogAsinLogUpdatePost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/AsinLogUpdate`, method: 'post', params, data })
}
export const apiV1BusinessAsinLogDeleteFilePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/deleteFile`, method: 'post', data })
}
export const apiV1BusinessAsinLogUploadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessAsinLog/upload`, method: 'post', data })
}
export const apiV1BusinessAsinTaskAsinLogRedPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/AsinLogRed`, method: 'post', params })
}
export const apiV1BusinessAsinTaskAsinTaskAddPost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/AsinTaskAdd`, method: 'post', params, data })
}
export const apiV1BusinessAsinTaskAsinTaskRemoveIdIdsDelete = (ids, params) => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/AsinTaskRemoveId/${ids}`, method: 'delete', params })
}
export const apiV1BusinessAsinTaskAsinTaskUpdatePost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/AsinTaskUpdate`, method: 'post', params, data })
}
export const apiV1BusinessAsinTaskAsinTaskVoListGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/AsinTaskVOList`, method: 'get', params })
}
export const apiV1BusinessAsinTaskTaskVosLIstPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/TASK_VOS_lIST`, method: 'post' })
}
export const apiV1BusinessAsinTaskUpdateAsinLogGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessAsinTask/UPDATEAsinLog`, method: 'get', params })
}
export const apiV1BusinessBaseSysUserShopAccountRelationAuthSysUserPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessBaseSysUserShopAccountRelation/authSysUser`, method: 'post', data })
}
export const apiV1BusinessBaseSysUserShopAccountRelationGetAuthListByPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessBaseSysUserShopAccountRelation/getAuthListByPage`, method: 'post', data })
}
export const apiV1BusinessBaseSysUserShopAccountRelationGetCodeIdPost = (id, params) => {
  return request({ url: `/hhxc-business/api/v1/businessBaseSysUserShopAccountRelation/getCode/${id}`, method: 'post', params })
}
export const apiV1BusinessBaseSysUserShopAccountRelationGetShopAccountListByPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessBaseSysUserShopAccountRelation/getShopAccountListByPage`, method: 'post', data })
}
export const apiV1BusinessFncProductProfitCalculationPageAllPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/PageAll`, method: 'post', data })
}
export const apiV1BusinessFncProductProfitCalculationCopyMeasurementIdPost = (id, params) => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/copyMeasurement/${id}`, method: 'post', params })
}
export const apiV1BusinessFncProductProfitCalculationDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/delete/${id}`, method: 'post', params })
}
export const apiV1BusinessFncProductProfitCalculationDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessFncProductProfitCalculationExchangeRateGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/exchangeRate`, method: 'get' })
}
export const apiV1BusinessFncProductProfitCalculationImportFilePost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/importFile`, method: 'post', data: formData })
}
export const apiV1BusinessFncProductProfitCalculationPriceGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/price`, method: 'get', params })
}
export const apiV1BusinessFncProductProfitCalculationProfitMeasurementPost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessFncProductProfitCalculation/profitMeasurement`, method: 'post', params, data })
}
export const apiV1BusinessInvCustomsDeclarationBatchLogisticsCostDisplayPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/BatchLogisticsCostDisplay`, method: 'post', params })
}
export const apiV1BusinessInvCustomsDeclarationLogisticsCostCreatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/LogisticsCostCreate`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationLogisticsTrajectoryCreatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/LogisticsTrajectoryCreate`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationLogisticsTrajectoryDisplayPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/LogisticsTrajectoryDisplay`, method: 'post', params })
}
export const apiV1BusinessInvCustomsDeclarationPageAllPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/PageAll`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationTrackingCreatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/TrackingCreate`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationTrackingDisplayPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/TrackingDisplay`, method: 'post', params })
}
export const apiV1BusinessInvCustomsDeclarationTransferBatchCreatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/TransferBatchCreate`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationTransferBatchItemsPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/TransferBatchItems`, method: 'post', params })
}
export const apiV1BusinessInvCustomsDeclarationTransferBatchPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/TransferBatchPage`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationCustomsDeclarationDetailsGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/customsDeclarationDetails`, method: 'get', params })
}
export const apiV1BusinessInvCustomsDeclarationCustomsDeclarationUpdatePost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/customsDeclarationUpdate`, method: 'post', params, data })
}
export const apiV1BusinessInvCustomsDeclarationDeleteGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/delete`, method: 'get', params })
}
export const apiV1BusinessInvCustomsDeclarationDownloadDeclarationGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/downloadDeclaration`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessInvCustomsDeclarationFindAllPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/findAll`, method: 'post' })
}
export const apiV1BusinessInvCustomsDeclarationKdRatePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/kdRate`, method: 'post' })
}
export const apiV1BusinessInvCustomsDeclarationPtsNamePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/ptsName`, method: 'post' })
}
export const apiV1BusinessInvCustomsDeclarationUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/update`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationUploadBatchPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/uploadBatch`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationUploadBatchLogisticsCostPost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/uploadBatchLogisticsCost`, method: 'post', params, data })
}
export const apiV1BusinessInvCustomsDeclarationUploadBatchLogisticsTrajectoryCreatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/uploadBatchLogisticsTrajectoryCreate`, method: 'post', data })
}
export const apiV1BusinessInvCustomsDeclarationUploadBatchTrackingCreatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvCustomsDeclaration/uploadBatchTrackingCreate`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryBillAuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/audit/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryBillDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessInvReturnDeliveryBillDownloadItemListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/downloadItemList`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnDeliveryBillGetDetailBillNoGet = (billNo, params) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/getDetail/${billNo}`, method: 'get', params })
}
export const apiV1BusinessInvReturnDeliveryBillGetItemListByPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/getItemListByPage`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryBillItemsPushMatchTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/itemsPushMatch/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryBillSavePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/save`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryBillUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/update`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryBillUpdateTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryBill/update/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2AuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/audit/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2CloseTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/close/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2DeletePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/delete`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2DownloadTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/download/${type}`, method: 'post', params, data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnDeliveryNoteV2ItemsPushMatchTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/itemsPushMatch/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2LineCloseTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/lineClose/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2ListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/list`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2RetrySendAkPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/retrySendAk`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2SavePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/save`, method: 'post', data })
}
export const apiV1BusinessInvReturnDeliveryNoteV2SendAkPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnDeliveryNoteV2/sendAk`, method: 'post', data })
}
export const apiV1BusinessInvReturnNotificationBillItemCustomExportDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/CustomExportDownload`, method: 'get', params, responseType: 'blob' })
}
export const apiV1BusinessInvReturnNotificationBillItemDownloadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/download`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnNotificationBillItemGetDetailNotifyNoGet = (notifyNo, params) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/getDetail/${notifyNo}`, method: 'get', params })
}
export const apiV1BusinessInvReturnNotificationBillItemGetNotificationBillItemPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/getNotificationBillItemPage`, method: 'post', data })
}
export const apiV1BusinessInvReturnNotificationBillItemGetPurInTransitDataPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/getPurInTransitDataPage`, method: 'post', data })
}
export const apiV1BusinessInvReturnNotificationBillItemItemsPushMatchTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/itemsPushMatch/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnNotificationBillItemPreCheckSavePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/preCheck/save`, method: 'post', data })
}
export const apiV1BusinessInvReturnNotificationBillItemSavePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/save`, method: 'post', data })
}
export const apiV1BusinessInvReturnNotificationBillItemUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnNotificationBillItem/update`, method: 'post', data })
}
export const apiV1BusinessInvReturnOperateRemarkGetListByPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnOperateRemark/getListByPage`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListAuditLogGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/AuditLog`, method: 'get', params })
}
export const apiV1BusinessInvReturnPlanListOrderReceivingItemUpdatePost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/OrderReceivingItemUpdate`, method: 'post', params })
}
export const apiV1BusinessInvReturnPlanListPlanItemGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/PlanItem`, method: 'get', params })
}
export const apiV1BusinessInvReturnPlanListReceiptOrderReceivingAuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/ReceiptOrderReceivingAudit/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListReceiptOrderReceivingDeleteTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/ReceiptOrderReceivingDelete/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListReceiptOrderReceivingPageListGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/ReceiptOrderReceivingPageList`, method: 'get', params })
}
export const apiV1BusinessInvReturnPlanListReceiptOrderReceivingPushMatchGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/ReceiptOrderReceivingPushMatch`, method: 'get', params })
}
export const apiV1BusinessInvReturnPlanListReceiptOrderReceivingSavePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/ReceiptOrderReceivingSave`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListCloseStatusPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/closeStatus`, method: 'post', params })
}
export const apiV1BusinessInvReturnPlanListDeletePost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/delete`, method: 'post', params })
}
export const apiV1BusinessInvReturnPlanListDeleteIdPost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/deleteId`, method: 'post', params })
}
export const apiV1BusinessInvReturnPlanListDocumentAuditGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/documentAudit`, method: 'get', params })
}
export const apiV1BusinessInvReturnPlanListDownloadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/download`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnPlanListDownloadItemListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/downloadItemList`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnPlanListFilesDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/filesDelete/${id}`, method: 'post', params })
}
export const apiV1BusinessInvReturnPlanListImportFilePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/importFile`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnPlanListImportFileStatusPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/importFileStatus`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListImportMultiChannelFilePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/importMultiChannelFile`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListLineClosePost = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/lineClose`, method: 'post', params })
}
export const apiV1BusinessInvReturnPlanListListGet = params => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/list`, method: 'get', params })
}
export const apiV1BusinessInvReturnPlanListListClassGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/listClass`, method: 'get' })
}
export const apiV1BusinessInvReturnPlanListUpdatePost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/update`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListUploadIdPost = (id, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/upload/${id}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListWeekListGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanList/weekList`, method: 'get' })
}
export const apiV1BusinessInvReturnPlanListV2AccountInfoPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/AccountInfo`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListV2DicPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/Dic`, method: 'post' })
}
export const apiV1BusinessInvReturnPlanListV2ListPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/ListPage`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListV2AuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/audit/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListV2CloseTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/close/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListV2CreateInvStraightHairPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/createInvStraightHair`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListV2DeleteTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/delete/${type}`, method: 'post', params, data })
}
export const apiV1BusinessInvReturnPlanListV2DownloadPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/download`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnPlanListV2ImportFilePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/importFile`, method: 'post', data })
}
export const apiV1BusinessInvReturnPlanListV2ImportFileErrPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/importFileErr`, method: 'post', data, responseType: 'blob' })
}
export const apiV1BusinessInvReturnPlanListV2UpdatePost = data => {
  return request({ url: `/hhxc-business/api/v1/businessInvReturnPlanListV2/update`, method: 'post', data })
}
export const apiV1BusinessProductCategoriesAddPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessProductCategories/add`, method: 'post', data })
}
export const apiV1BusinessProductCategoriesDeletePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessProductCategories/delete`, method: 'post' })
}
export const apiV1BusinessProductCategoriesListPost = data => {
  return request({ url: `/hhxc-business/api/v1/businessProductCategories/list`, method: 'post', data })
}
export const apiV1BusinessProductCategoriesProductTreeGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessProductCategories/productTree`, method: 'get' })
}
export const apiV1BusinessProductCategoriesTreeGet = () => {
  return request({ url: `/hhxc-business/api/v1/businessProductCategories/tree`, method: 'get' })
}
export const apiV1BusinessProductCategoriesUpdatePost = () => {
  return request({ url: `/hhxc-business/api/v1/businessProductCategories/update`, method: 'post' })
}
export const apiV1BusinessProductKnowledgeBaseTreeListPost = () => {
  return request({ url: `/hhxc-business/api/v1/businessProductKnowledgeBase/treeList`, method: 'post' })
}
export const apiV1CommonFunction047Bbb433Dcf47Feb657E3E4Bfab79AeGetAiPowerImproveCredentialPost = params => {
  return request({ url: `/hhxc-business/api/v1/common/function/047bbb433dcf47feb657e3e4bfab79ae/getAiPowerImproveCredential`, method: 'post', params })
}
export const apiV1CommonFunction047Bbb433Dcf47Feb657E3E4Bfab79AeProcess2Post = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/047bbb433dcf47feb657e3e4bfab79ae/process2`, method: 'post', data })
}
export const apiV1CommonFunction047Bbb433Dcf47Feb657E3E4Bfab79AeStartRpaGetAsinInfoPost = params => {
  return request({ url: `/hhxc-business/api/v1/common/function/047bbb433dcf47feb657e3e4bfab79ae/startRpaGetAsinInfo`, method: 'post', params })
}
export const apiV1CommonFunction047Bbb433Dcf47Feb657E3E4Bfab79AeSynchronicAbaPost = () => {
  return request({ url: `/hhxc-business/api/v1/common/function/047bbb433dcf47feb657e3e4bfab79ae/synchronicAba`, method: 'post' })
}
export const apiV1CommonFunction047Bbb433Dcf47Feb657E3E4Bfab79AeSynchronicKeywordPost = () => {
  return request({ url: `/hhxc-business/api/v1/common/function/047bbb433dcf47feb657e3e4bfab79ae/synchronicKeyword`, method: 'post' })
}
export const apiV1CommonFunctionAsinInfoCallBackPost = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/asinInfoCallBack`, method: 'post', data })
}
export const apiV1CommonFunctionAsinInfoYingDaoCallBackPost = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/asinInfoYingDaoCallBack`, method: 'post', data })
}
export const apiV1CommonFunctionGetAsinByProductLevelPost = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/getAsinByProductLevel`, method: 'post', data })
}
export const apiV1CommonFunctionGetPlanShipmentListPost = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/getPlanShipmentList`, method: 'post', data })
}
export const apiV1CommonFunctionPostAsinsPost = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/postAsins`, method: 'post', data })
}
export const apiV1CommonFunctionSaveExchangeListPost = data => {
  return request({ url: `/hhxc-business/api/v1/common/function/saveExchangeList`, method: 'post', data })
}
export const apiV1CommonFunctionShopConfigPost = () => {
  return request({ url: `/hhxc-business/api/v1/common/function/shopConfig`, method: 'post' })
}
export const apiV1CustomsInfoDeleteCustomsClearanceInfoPost = params => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/deleteCustomsClearanceInfo`, method: 'post', params })
}
export const apiV1CustomsInfoDeleteCustomsInfoPost = params => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/deleteCustomsInfo`, method: 'post', params })
}
export const apiV1CustomsInfoExportCustomsClearanceInfoPost = params => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/exportCustomsClearanceInfo`, method: 'post', params, responseType: 'blob' })
}
export const apiV1CustomsInfoExportCustomsInfoPost = params => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/exportCustomsInfo`, method: 'post', params, responseType: 'blob' })
}
export const apiV1CustomsInfoGetOnePost = params => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/getOne`, method: 'post', params })
}
export const apiV1CustomsInfoImportCustomsClearanceInfoPost = (params, data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/api/v1/customsInfo/importCustomsClearanceInfo`, method: 'post', params, data: formData })
}
export const apiV1CustomsInfoImportCustomsInfoPost = (params, data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/api/v1/customsInfo/importCustomsInfo`, method: 'post', params, data: formData })
}
export const apiV1CustomsInfoListPost = data => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/list`, method: 'post', data })
}
export const apiV1CustomsInfoSavePost = data => {
  return request({ url: `/hhxc-business/api/v1/customsInfo/save`, method: 'post', data })
}
export const apiV1ExcelDownloadBizTypeGet = (bizType, params) => {
  return request({ url: `/hhxc-business/api/v1/excel/download/${bizType}`, method: 'get', params, responseType: 'blob' })
}
export const apiV1ExchangeRatePost = data => {
  return request({ url: `/hhxc-business/api/v1/exchangeRate`, method: 'post', data })
}
export const apiV1FbaShipmentPost = data => {
  return request({ url: `/hhxc-business/api/v1/fbaShipment`, method: 'post', data })
}
export const apiV1FbaShipmentGetIsellerpalFbaShipmentListGet = () => {
  return request({ url: `/hhxc-business/api/v1/fbaShipment/getIsellerpalFbaShipmentList`, method: 'get' })
}
export const apiV1FbaShipmentShipmentStatusPost = () => {
  return request({ url: `/hhxc-business/api/v1/fbaShipment/shipmentStatus`, method: 'post' })
}
export const apiV1FbaShipmentShipmentIdGet = (shipmentId, params) => {
  return request({ url: `/hhxc-business/api/v1/fbaShipment/${shipmentId}`, method: 'get', params })
}
export const apiV1FbaShipmentItemIdPatch = (id, params) => {
  return request({ url: `/hhxc-business/api/v1/fbaShipmentItem/${id}`, method: 'patch', params })
}
export const apiV1FrfillAmzonInvCreateShipmentListPageAllPost = data => {
  return request({ url: `/hhxc-business/api/v1/frfillAmzonInvCreateShipmentList/PageAll`, method: 'post', data })
}
export const apiV1FrfillAmzonInvCreateShipmentListImportFileStatusUserPost = (user, params, data) => {
  return request({ url: `/hhxc-business/api/v1/frfillAmzonInvCreateShipmentList/importFileStatus/${user}`, method: 'post', params, data })
}
export const apiV1FrfillAmzonInvCreateShipmentListStoreNameCreatedPost = () => {
  return request({ url: `/hhxc-business/api/v1/frfillAmzonInvCreateShipmentList/storeNameCreated`, method: 'post' })
}
export const apiV1FrfillAmzonInvCreateShipmentListUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v1/frfillAmzonInvCreateShipmentList/update`, method: 'post', data })
}
export const apiV1KdMaterialGroupChildrenPost = () => {
  return request({ url: `/hhxc-business/api/v1/kdMaterialGroup/children`, method: 'post' })
}
export const apiV1KdMaterialGroupGeneratePost = params => {
  return request({ url: `/hhxc-business/api/v1/kdMaterialGroup/generate`, method: 'post', params })
}
export const apiV1KingDeeFbaSyncDataGet = () => {
  return request({ url: `/hhxc-business/api/v1/kingDeeFba/syncData`, method: 'get' })
}
export const apiV1KingDeeInventorySyncDataGet = () => {
  return request({ url: `/hhxc-business/api/v1/kingDeeInventory/syncData`, method: 'get' })
}
export const apiV1KingDeePurchaseSyncDateGet = () => {
  return request({ url: `/hhxc-business/api/v1/kingDeePurchase/syncDate`, method: 'get' })
}
export const apiV1KingDeeStarSyncDataGet = () => {
  return request({ url: `/hhxc-business/api/v1/kingDeeStar/syncData`, method: 'get' })
}
export const apiV1KingDeeTransitSyncDataGet = () => {
  return request({ url: `/hhxc-business/api/v1/kingDeeTransit/syncData`, method: 'get' })
}
export const apiV1MlAcceptOrderGetOrderStatusPost = () => {
  return request({ url: `/hhxc-business/api/v1/mlAcceptOrder/getOrderStatus`, method: 'post' })
}
export const apiV1MlAcceptOrderSyncDataPost = () => {
  return request({ url: `/hhxc-business/api/v1/mlAcceptOrder/syncData`, method: 'post' })
}
export const apiV1OssFileGetSignaturePost = params => {
  return request({ url: `/hhxc-business/api/v1/ossFile/getSignature`, method: 'post', params })
}
export const apiV1OssFileGetSignatureListPost = data => {
  return request({ url: `/hhxc-business/api/v1/ossFile/getSignatureList`, method: 'post', data })
}
export const apiV1OssFileUploadBizTypePost = (bizType, params, data) => {
  return request({ url: `/hhxc-business/api/v1/ossFile/upload/${bizType}`, method: 'post', params, data })
}
export const apiV1ProductLeaderDeletePost = params => {
  return request({ url: `/hhxc-business/api/v1/productLeader/delete`, method: 'post', params })
}
export const apiV1ProductLeaderEditPost = params => {
  return request({ url: `/hhxc-business/api/v1/productLeader/edit`, method: 'post', params })
}
export const apiV1ProductLeaderExportPost = data => {
  return request({ url: `/hhxc-business/api/v1/productLeader/export`, method: 'post', data, responseType: 'blob' })
}
export const apiV1ProductLeaderImportPost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/api/v1/productLeader/import`, method: 'post', data: formData })
}
export const apiV1ProductLeaderListPost = data => {
  return request({ url: `/hhxc-business/api/v1/productLeader/list`, method: 'post', data })
}
export const apiV1SalePlanAddMarketplaceGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/AddMarketplace`, method: 'get', params })
}
export const apiV1SalePlanAsinVoListGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/AsinVOList`, method: 'get', params })
}
export const apiV1SalePlanBillsAsinSavePlannedGranularityPost = (plannedGranularity, params, data) => {
  return request({ url: `/hhxc-business/api/v1/salePlan/BillsAsinSave/${plannedGranularity}`, method: 'post', params, data })
}
export const apiV1SalePlanBillsAsinUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v1/salePlan/BillsAsinUpdate`, method: 'post', data })
}
export const apiV1SalePlanBillsItemAddGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/BillsItemAdd`, method: 'get', params })
}
export const apiV1SalePlanBillsMonthVoGet = data => {
  return request({ url: `/hhxc-business/api/v1/salePlan/BillsMonthVO`, method: 'get', data })
}
export const apiV1SalePlanDetailsGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/Details`, method: 'get', params })
}
export const apiV1SalePlanKanBanListGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/KanBanList`, method: 'get', params })
}
export const apiV1SalePlanKanBanListExportGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/KanBanListExport`, method: 'get', params, responseType: 'blob' })
}
export const apiV1SalePlanListingAsinExcelGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/ListingAsinExcel`, method: 'get', params, responseType: 'blob' })
}
export const apiV1SalePlanMonthAdjustVoAsinListGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/MonthAdjustVOAsinList`, method: 'get', params })
}
export const apiV1SalePlanParentAsinHistoryVoListGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/ParentAsinHistoryVOList`, method: 'get', params })
}
export const apiV1SalePlanParentAsinVoList1Get = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/ParentAsinVOList1`, method: 'get', params })
}
export const apiV1SalePlanSalePreparerIdGet = () => {
  return request({ url: `/hhxc-business/api/v1/salePlan/SalePreparerId`, method: 'get' })
}
export const apiV1SalePlanSaleSkedSubtasksGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/SaleSkedSubtasks`, method: 'get', params })
}
export const apiV1SalePlanSummaryVoGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/SummaryVO`, method: 'get', params })
}
export const apiV1SalePlanAaaaaaaGet = () => {
  return request({ url: `/hhxc-business/api/v1/salePlan/aaaaaaa`, method: 'get' })
}
export const apiV1SalePlanBillSvoListGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/billSVOList`, method: 'get', params })
}
export const apiV1SalePlanBillSvoList11Post = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/billSVOList11`, method: 'post', params })
}
export const apiV1SalePlanHistoryGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/history`, method: 'get', params })
}
export const apiV1SalePlanListGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/list`, method: 'get', params })
}
export const apiV1SalePlanListAllByAsinBusinessBillsPost = data => {
  return request({ url: `/hhxc-business/api/v1/salePlan/listAllByAsinBusinessBills`, method: 'post', data })
}
export const apiV1SalePlanPidGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/pid`, method: 'get', params })
}
export const apiV1SalePlanPrimaryVoiPageGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/primaryVOIPage`, method: 'get', params })
}
export const apiV1SalePlanRemoveplannedIdsDelete = (ids, params) => {
  return request({ url: `/hhxc-business/api/v1/salePlan/removeplanned/${ids}`, method: 'delete', params })
}
export const apiV1SalePlanRevampGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/revamp`, method: 'get', params })
}
export const apiV1SalePlanUpdateStuaPost = data => {
  return request({ url: `/hhxc-business/api/v1/salePlan/updateStua`, method: 'post', data })
}
export const apiV1SalePlanUpdatepalnStratGet = params => {
  return request({ url: `/hhxc-business/api/v1/salePlan/updatepalnStrat`, method: 'get', params })
}
export const apiV1SalePlanUploadAsinPost = (params, data) => {
  return request({ url: `/hhxc-business/api/v1/salePlan/uploadAsin`, method: 'post', params, data })
}
export const apiV1SalePlanPlanIdDelete = (planId, params) => {
  return request({ url: `/hhxc-business/api/v1/salePlan/${planId}`, method: 'delete', params })
}
export const apiV1SaveExchangeListPost = data => {
  return request({ url: `/hhxc-business/api/v1/saveExchangeList`, method: 'post', data })
}
export const apiV1StockKanbanAsinStockDetailAsinPost = (asin, params) => {
  return request({ url: `/hhxc-business/api/v1/stockKanban/asinStockDetail/${asin}`, method: 'post', params })
}
export const apiV1StockKanbanAsinStockPageListPost = data => {
  return request({ url: `/hhxc-business/api/v1/stockKanban/asinStockPageList`, method: 'post', data })
}
export const apiV1StockKanbanProductStockDetailMaterialIdPost = (materialId, params) => {
  return request({ url: `/hhxc-business/api/v1/stockKanban/productStockDetail/${materialId}`, method: 'post', params })
}
export const apiV1StockKanbanProductStockPageListPost = data => {
  return request({ url: `/hhxc-business/api/v1/stockKanban/productStockPageList`, method: 'post', data })
}
export const apiV1StockKanbanSyncStockKanbanPost = () => {
  return request({ url: `/hhxc-business/api/v1/stockKanban/syncStockKanban`, method: 'post' })
}
export const apiV1SyncKdBaseSupplierListUserAddPost = data => {
  return request({ url: `/hhxc-business/api/v1/syncKdBaseSupplierList/UserAdd`, method: 'post', data })
}
export const apiV1SyncKdBaseSupplierListGetDetailSupplierNumberGet = (supplierNumber, params) => {
  return request({ url: `/hhxc-business/api/v1/syncKdBaseSupplierList/getDetail/${supplierNumber}`, method: 'get', params })
}
export const apiV1SyncKdBaseSupplierListSelectPagePost = data => {
  return request({ url: `/hhxc-business/api/v1/syncKdBaseSupplierList/selectPage`, method: 'post', data })
}
export const apiV1TransBaiduPost = data => {
  return request({ url: `/hhxc-business/api/v1/trans/baidu`, method: 'post', data })
}
export const apiV1YingdaoStartRpaTaskPost = data => {
  return request({ url: `/hhxc-business/api/v1/yingdao/startRpaTask`, method: 'post', data })
}
export const apiV2BusinessInvReturnDeliveryBillAuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/audit/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnDeliveryBillDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/download`, method: 'get', params, responseType: 'blob' })
}
export const apiV2BusinessInvReturnDeliveryBillDownloadItemListPost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/downloadItemList`, method: 'post', data, responseType: 'blob' })
}
export const apiV2BusinessInvReturnDeliveryBillGetDetailBillNoGet = (billNo, params) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/getDetail/${billNo}`, method: 'get', params })
}
export const apiV2BusinessInvReturnDeliveryBillGetItemListByPagePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/getItemListByPage`, method: 'post', data })
}
export const apiV2BusinessInvReturnDeliveryBillItemsPushMatchTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/itemsPushMatch/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnDeliveryBillPushAkReceiptOrderPost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/pushAkReceiptOrder`, method: 'post', data })
}
export const apiV2BusinessInvReturnDeliveryBillSavePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/save`, method: 'post', data })
}
export const apiV2BusinessInvReturnDeliveryBillUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/update`, method: 'post', data })
}
export const apiV2BusinessInvReturnDeliveryBillUpdateTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnDeliveryBill/update/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnNotificationBillAuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBill/audit/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnNotificationBillImportUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBill/importUpdate`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillImportUpdateShipmentIdPost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBill/importUpdateShipmentId`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillImportUpdateShipmentLabelPost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBill/importUpdateShipmentLabel`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillShipmentPrintFbaLabelsShipmentIdPost = (shipmentId, params) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBill/shipment/printFbaLabels/${shipmentId}`, method: 'post', params })
}
export const apiV2BusinessInvReturnNotificationBillUpdateTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBill/update/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnNotificationBillItemCustomExportDownloadGet = params => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/CustomExportDownload`, method: 'get', params, responseType: 'blob' })
}
export const apiV2BusinessInvReturnNotificationBillItemDirectItemsPushMatchTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/directItemsPushMatch/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnNotificationBillItemDirectPushSavePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/directPushSave`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillItemDownloadPost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/download`, method: 'post', data, responseType: 'blob' })
}
export const apiV2BusinessInvReturnNotificationBillItemGetDetailNotifyNoGet = (notifyNo, params) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/getDetail/${notifyNo}`, method: 'get', params })
}
export const apiV2BusinessInvReturnNotificationBillItemGetNotificationBillItemPagePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/getNotificationBillItemPage`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillItemGetPurInTransitDataPagePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/getPurInTransitDataPage`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillItemItemsPushMatchTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/itemsPushMatch/${type}`, method: 'post', params, data })
}
export const apiV2BusinessInvReturnNotificationBillItemSavePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/save`, method: 'post', data })
}
export const apiV2BusinessInvReturnNotificationBillItemUpdatePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessInvReturnNotificationBillItem/update`, method: 'post', data })
}
export const apiV2BusinessSalesSaleMultiplatformPlanListDicPost = () => {
  return request({ url: `/hhxc-business/api/v2/businessSalesSaleMultiplatformPlanList/Dic`, method: 'post' })
}
export const apiV2BusinessSalesSaleMultiplatformPlanListListPagePost = data => {
  return request({ url: `/hhxc-business/api/v2/businessSalesSaleMultiplatformPlanList/ListPage`, method: 'post', data })
}
export const apiV2BusinessSalesSaleMultiplatformPlanListAuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/api/v2/businessSalesSaleMultiplatformPlanList/audit/${type}`, method: 'post', params, data })
}
export const apiV2BusinessSalesSaleMultiplatformPlanListExportTableGet = params => {
  return request({ url: `/hhxc-business/api/v2/businessSalesSaleMultiplatformPlanList/exportTable`, method: 'get', params, responseType: 'blob' })
}
export const apiV2BusinessSalesSaleMultiplatformPlanListImportFilePost = (params, data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/api/v2/businessSalesSaleMultiplatformPlanList/importFile`, method: 'post', params, data: formData })
}
export const apiV2FbaShipmentListPost = data => {
  return request({ url: `/hhxc-business/api/v2/fbaShipment/list`, method: 'post', data })
}
export const apiV2FbaShipmentOrderPost = data => {
  return request({ url: `/hhxc-business/api/v2/fbaShipment/order`, method: 'post', data })
}
export const apiV2OutBoundManagementCreatorListPost = () => {
  return request({ url: `/hhxc-business/api/v2/outBoundManagement/creatorList`, method: 'post' })
}
export const apiV2OutBoundManagementGetListByPagePost = params => {
  return request({ url: `/hhxc-business/api/v2/outBoundManagement/getListByPage`, method: 'post', params })
}
export const apiV2OutBoundManagementImportExcelPost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/api/v2/outBoundManagement/importExcel`, method: 'post', data: formData })
}
export const apiV2OutBoundManagementOutDeletePost = data => {
  return request({ url: `/hhxc-business/api/v2/outBoundManagement/outDelete`, method: 'post', data })
}
export const apiV2OutBoundManagementOutExportGet = () => {
  return request({ url: `/hhxc-business/api/v2/outBoundManagement/outExport`, method: 'get', responseType: 'blob' })
}
export const apiV2ProfitMeasurementExchangeRateListPost = () => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/exchangeRateList`, method: 'post' })
}
export const apiV2ProfitMeasurementExportMeasurementPost = () => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/exportMeasurement`, method: 'post' })
}
export const apiV2ProfitMeasurementGetSiteDefaultDataPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/getSiteDefaultData`, method: 'post', data })
}
export const apiV2ProfitMeasurementGetTransportDefaultDataPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/getTransportDefaultData`, method: 'post', data })
}
export const apiV2ProfitMeasurementImportExcelTemplatePost = () => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/importExcelTemplate`, method: 'post' })
}
export const apiV2ProfitMeasurementImportMeasurementPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/importMeasurement`, method: 'post', data })
}
export const apiV2ProfitMeasurementLoadMeasurementPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/loadMeasurement`, method: 'post', data })
}
export const apiV2ProfitMeasurementMeasurementListPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/measurementList`, method: 'post', data })
}
export const apiV2ProfitMeasurementPlatformListPost = () => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/platformList`, method: 'post' })
}
export const apiV2ProfitMeasurementRemoveMeasurementPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/removeMeasurement`, method: 'post', data })
}
export const apiV2ProfitMeasurementSaveMeasurementPost = data => {
  return request({ url: `/hhxc-business/api/v2/profitMeasurement/saveMeasurement`, method: 'post', data })
}
export const businessAdCampaignReportTowCampaignReportTowPost = params => {
  return request({ url: `/hhxc-business/businessAdCampaignReportTow/campaignReportTow`, method: 'post', params })
}
export const businessAdvertPlanAdBrandPlanHistoryVoGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/AdBrandPlanHistoryVO`, method: 'get', params })
}
export const businessAdvertPlanAdBrandPlanVoListGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/AdBrandPlanVOList`, method: 'get', params })
}
export const businessAdvertPlanBusinessAdvertPlanBardVoListGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/BusinessAdvertPlanBardVOList`, method: 'get', params })
}
export const businessAdvertPlanDetailsVoAdvertPlanIdGet = (advertPlanId, params) => {
  return request({ url: `/hhxc-business/businessAdvertPlan/DetailsVO/${advertPlanId}`, method: 'get', params })
}
export const businessAdvertPlanPlanProductHistoryVoGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/PlanProductHistoryVO`, method: 'get', params })
}
export const businessAdvertPlanPlanProductVoGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/PlanProductVO`, method: 'get', params })
}
export const businessAdvertPlanProductAsinVoGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/ProductAsinVO`, method: 'get', params })
}
export const businessAdvertPlanUpdateSkuPost = data => {
  return request({ url: `/hhxc-business/businessAdvertPlan/UpdateSku`, method: 'post', data })
}
export const businessAdvertPlanAddAdvertPlanPost = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/addAdvertPlan`, method: 'post', params })
}
export const businessAdvertPlanAddTargetPost = data => {
  return request({ url: `/hhxc-business/businessAdvertPlan/addTarget`, method: 'post', data })
}
export const businessAdvertPlanBrandNameGet = () => {
  return request({ url: `/hhxc-business/businessAdvertPlan/brandName`, method: 'get' })
}
export const businessAdvertPlanBrandNameListPost = () => {
  return request({ url: `/hhxc-business/businessAdvertPlan/brandNameList`, method: 'post' })
}
export const businessAdvertPlanCharacteristicGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/characteristic`, method: 'get', params })
}
export const businessAdvertPlanFoundIdGet = () => {
  return request({ url: `/hhxc-business/businessAdvertPlan/foundId`, method: 'get' })
}
export const businessAdvertPlanListProductPost = () => {
  return request({ url: `/hhxc-business/businessAdvertPlan/listProduct`, method: 'post' })
}
export const businessAdvertPlanPlanListGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/planList`, method: 'get', params })
}
export const businessAdvertPlanRemoveIdIdsDelete = (ids, params) => {
  return request({ url: `/hhxc-business/businessAdvertPlan/removeId/${ids}`, method: 'delete', params })
}
export const businessAdvertPlanUpdateStartGet = params => {
  return request({ url: `/hhxc-business/businessAdvertPlan/updateStart`, method: 'get', params })
}
export const businessAdvertPlanAdvertPlanIdDelete = (advertPlanId, params) => {
  return request({ url: `/hhxc-business/businessAdvertPlan/${advertPlanId}`, method: 'delete', params })
}
export const businessInvReturnNotificationBillAuditTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/businessInvReturnNotificationBill/audit/${type}`, method: 'post', params, data })
}
export const businessInvReturnNotificationBillImportUpdatePost = data => {
  return request({ url: `/hhxc-business/businessInvReturnNotificationBill/importUpdate`, method: 'post', data })
}
export const businessInvReturnNotificationBillPlannerAuditPost = (params, data) => {
  return request({ url: `/hhxc-business/businessInvReturnNotificationBill/plannerAudit`, method: 'post', params, data })
}
export const businessInvReturnNotificationBillUpdateTypePost = (type, params, data) => {
  return request({ url: `/hhxc-business/businessInvReturnNotificationBill/update/${type}`, method: 'post', params, data })
}
export const businessInvStraightHairReportListDeletePost = params => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/Delete`, method: 'post', params })
}
export const businessInvStraightHairReportListHairReportDoGetGet = params => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/HairReport/doGet`, method: 'get', params })
}
export const businessInvStraightHairReportListHairReportDoPostPost = () => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/HairReport/doPost`, method: 'post' })
}
export const businessInvStraightHairReportListInvStraightHairItemPost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/InvStraightHairItem`, method: 'post', data })
}
export const businessInvStraightHairReportListPageAllPost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/PageAll`, method: 'post', data })
}
export const businessInvStraightHairReportListStatusModificationPost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/StatusModification`, method: 'post', data })
}
export const businessInvStraightHairReportListStraightHairAuditPost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/StraightHairAudit`, method: 'post', data })
}
export const businessInvStraightHairReportListDictionaryPost = () => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/dictionary`, method: 'post' })
}
export const businessInvStraightHairReportListDownloadGet = params => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/download`, method: 'get', params, responseType: 'blob' })
}
export const businessInvStraightHairReportListImageUploadPost = (params, data) => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/imageUpload`, method: 'post', params, data })
}
export const businessInvStraightHairReportListImportFileReportStatusPost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/importFileReportStatus`, method: 'post', data: formData })
}
export const businessInvStraightHairReportListImportReportFilePost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/importReportFile`, method: 'post', data, responseType: 'blob' })
}
export const businessInvStraightHairReportListOrderDeletePost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/orderDelete`, method: 'post', data })
}
export const businessInvStraightHairReportListRowStatusPost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/rowStatus`, method: 'post', data })
}
export const businessInvStraightHairReportListUpdatePost = params => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/update`, method: 'post', params })
}
export const businessInvStraightHairReportListUpdateDeletePost = data => {
  return request({ url: `/hhxc-business/businessInvStraightHairReportList/updateDelete`, method: 'post', data })
}
export const cockpitReportBrandMonthlyPerformanceDetailPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/brand-monthly-performance-detail`, method: 'post', data })
}
export const cockpitReportBrandMonthlyPerformanceTablePost = data => {
  return request({ url: `/hhxc-business/cockpit/report/brand-monthly-performance-table`, method: 'post', data })
}
export const cockpitReportBrandMonthlySankeyPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/brand-monthly-sankey`, method: 'post', data })
}
export const cockpitReportBrandNamesPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/brand-names`, method: 'post', data })
}
export const cockpitReportBrandSalesProportionPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/brand-sales-proportion`, method: 'post', data })
}
export const cockpitReportBrandWeeklyReportPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/brand-weekly-report`, method: 'post', data })
}
export const cockpitReportDataUpdateTimeGet = () => {
  return request({ url: `/hhxc-business/cockpit/report/data-update-time`, method: 'get' })
}
export const cockpitReportDepartmentNamesPost = () => {
  return request({ url: `/hhxc-business/cockpit/report/department-names`, method: 'post' })
}
export const cockpitReportMonthlyComparisonPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/monthly-comparison`, method: 'post', data })
}
export const cockpitReportMonthlyDetailPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/monthly-detail`, method: 'post', data })
}
export const cockpitReportMonthlyPerformancePost = data => {
  return request({ url: `/hhxc-business/cockpit/report/monthly-performance`, method: 'post', data })
}
export const cockpitReportPersonnelEfficiencyYoyPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/personnel-efficiency-yoy`, method: 'post', data })
}
export const cockpitReportProfitTrendPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/profit-trend`, method: 'post', data })
}
export const cockpitReportQuantityTrendPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/quantity-trend`, method: 'post', data })
}
export const cockpitReportSalesTrendPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/sales-trend`, method: 'post', data })
}
export const cockpitReportTeamNamesPost = data => {
  return request({ url: `/hhxc-business/cockpit/report/team-names`, method: 'post', data })
}
export const productAttributeCreatePost = data => {
  return request({ url: `/hhxc-business/product/attribute/create`, method: 'post', data })
}
export const productAttributeDeletePost = data => {
  return request({ url: `/hhxc-business/product/attribute/delete`, method: 'post', data })
}
export const productAttributeListPost = data => {
  return request({ url: `/hhxc-business/product/attribute/list`, method: 'post', data })
}
export const productAttributePagePost = data => {
  return request({ url: `/hhxc-business/product/attribute/page`, method: 'post', data })
}
export const productAttributeUpdatePost = data => {
  return request({ url: `/hhxc-business/product/attribute/update`, method: 'post', data })
}
export const productCategoryCreatePost = data => {
  return request({ url: `/hhxc-business/product/category/create`, method: 'post', data })
}
export const productCategoryDeletePost = data => {
  return request({ url: `/hhxc-business/product/category/delete`, method: 'post', data })
}
export const productCategoryExportGet = () => {
  return request({ url: `/hhxc-business/product/category/export`, method: 'get' })
}
export const productCategoryImportPost = data => {
  return request({ url: `/hhxc-business/product/category/import`, method: 'post', data })
}
export const productCategoryQueryPost = data => {
  return request({ url: `/hhxc-business/product/category/query`, method: 'post', data })
}
export const productCategoryTemplateDownloadGet = () => {
  return request({ url: `/hhxc-business/product/category/template/download`, method: 'get' })
}
export const productCategoryTreePost = data => {
  return request({ url: `/hhxc-business/product/category/tree`, method: 'post', data })
}
export const productCategoryUpdatePost = data => {
  return request({ url: `/hhxc-business/product/category/update`, method: 'post', data })
}
export const productCodeCreatePost = data => {
  return request({ url: `/hhxc-business/product/code/create`, method: 'post', data })
}
export const productCodeDeletePost = data => {
  return request({ url: `/hhxc-business/product/code/delete`, method: 'post', data })
}
export const productCodeDetailPost = data => {
  return request({ url: `/hhxc-business/product/code/detail`, method: 'post', data })
}
export const productCodeDownloadTemplateGet = params => {
  return request({ url: `/hhxc-business/product/code/downloadTemplate`, method: 'get', params })
}
export const productCodeImportPost = (params, data) => {
  return request({ url: `/hhxc-business/product/code/import`, method: 'post', params, data })
}
export const productCodePagePost = data => {
  return request({ url: `/hhxc-business/product/code/page`, method: 'post', data })
}
export const productCodePageAttributesSpuCodeGet = (spuCode, params) => {
  return request({ url: `/hhxc-business/product/code/pageAttributes/${spuCode}`, method: 'get', params })
}
export const productCodeSpecsSpuCodeGet = (spuCode, params) => {
  return request({ url: `/hhxc-business/product/code/specs/${spuCode}`, method: 'get', params })
}
export const productCodeUpdatePost = data => {
  return request({ url: `/hhxc-business/product/code/update`, method: 'post', data })
}
export const productCodeVersionsSpuCodeGet = (spuCode, params) => {
  return request({ url: `/hhxc-business/product/code/versions/${spuCode}`, method: 'get', params })
}
export const v1OldBusinessProductTransferApplicationGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1-old/businessProductTransferApplication/getListByPage`, method: 'post', data })
}
export const v1OldBusinessProductTransferApplicationRefreshMbGet = () => {
  return request({ url: `/hhxc-business/v1-old/businessProductTransferApplication/refreshMb`, method: 'get' })
}
export const v1OldBusinessProductTransferApplicationRefreshQwApprovalGet = () => {
  return request({ url: `/hhxc-business/v1-old/businessProductTransferApplication/refreshQwApproval`, method: 'get' })
}
export const v1OldBusinessProductTransferApplicationSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1-old/businessProductTransferApplication/saveOrUpdate`, method: 'post', data })
}
export const v1OldBusinessProductTransferApplicationWarehouseListGet = () => {
  return request({ url: `/hhxc-business/v1-old/businessProductTransferApplication/warehouseList`, method: 'get' })
}
export const v1BusinessBaseCountryGetCountryListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessBaseCountry/getCountryListByPage`, method: 'post', data })
}
export const v1BusinessBaseCountryGetListPost = data => {
  return request({ url: `/hhxc-business/v1/businessBaseCountry/getList`, method: 'post', data })
}
export const v1BusinessBaseShopPlatformDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessBaseShopPlatform/delete/${id}`, method: 'post', params })
}
export const v1BusinessBaseShopPlatformGetListPost = data => {
  return request({ url: `/hhxc-business/v1/businessBaseShopPlatform/getList`, method: 'post', data })
}
export const v1BusinessBaseShopPlatformGetShopPlatformListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessBaseShopPlatform/getShopPlatformListByPage`, method: 'post', data })
}
export const v1BusinessBaseShopPlatformSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessBaseShopPlatform/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileChatFileUploadPost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/chatFileUpload`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/delete/${id}`, method: 'post', params })
}
export const v1BusinessKnowledgeOssFileDeptListGet = () => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/deptList`, method: 'get' })
}
export const v1BusinessKnowledgeOssFileFileGroupDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/fileGroup/delete/${id}`, method: 'post', params })
}
export const v1BusinessKnowledgeOssFileFileGroupSavePost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/fileGroup/save`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileGetListByPageV2Post = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/getListByPageV2`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileGetSignaturePost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/getSignature`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileHistoryDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/history/delete/${id}`, method: 'post', params })
}
export const v1BusinessKnowledgeOssFileHistoryDetailIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/history/detail/${id}`, method: 'post', params })
}
export const v1BusinessKnowledgeOssFileHistoryGetPageListPost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/history/getPageList`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileHistorySaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/history/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFilePreviewSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/preview/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileStreamChatGet = params => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/streamChat`, method: 'get', params })
}
export const v1BusinessKnowledgeOssFileStreamChatV2Post = data => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/streamChatV2`, method: 'post', data })
}
export const v1BusinessKnowledgeOssFileTransferIdTargetFileTypePost = (id, targetFileType, params) => {
  return request({ url: `/hhxc-business/v1/businessKnowledgeOssFile/transfer/${id}/${targetFileType}`, method: 'post', params })
}
export const v1BusinessProductBaseDeletePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/delete`, method: 'post', data })
}
export const v1BusinessProductBaseExportLeveInfoPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/exportLeveInfo`, method: 'post', data })
}
export const v1BusinessProductBaseGetChangeLogListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getChangeLogListByPage`, method: 'post', data })
}
export const v1BusinessProductBaseGetColorListPost = () => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getColorList`, method: 'post' })
}
export const v1BusinessProductBaseGetDetailCodePost = (code, params) => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getDetail/${code}`, method: 'post', params })
}
export const v1BusinessProductBaseGetLevelListPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getLevelList`, method: 'post', data })
}
export const v1BusinessProductBaseGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getListByPage`, method: 'post', data })
}
export const v1BusinessProductBaseGetQueryConditionPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getQueryCondition`, method: 'post', data })
}
export const v1BusinessProductBaseGetSupplierListPost = () => {
  return request({ url: `/hhxc-business/v1/businessProductBase/getSupplierList`, method: 'post' })
}
export const v1BusinessProductBaseImportProductBasePost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductBase/importProductBase`, method: 'post', data: formData })
}
export const v1BusinessProductBaseImportProductBaseByAsinPost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductBase/importProductBaseByAsin`, method: 'post', data: formData })
}
export const v1BusinessProductBaseImportProductBoxTypePost = (type, params, data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductBase/importProductBox/${type}`, method: 'post', params, data: formData })
}
export const v1BusinessProductBaseImportProductReplacementTypePost = (type, params, data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductBase/importProductReplacement/${type}`, method: 'post', params, data: formData })
}
export const v1BusinessProductBaseImportProductTagTypePost = (type, params, data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductBase/importProductTag/${type}`, method: 'post', params, data: formData })
}
export const v1BusinessProductBasePushAsinKingPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/pushAsinKing`, method: 'post', data })
}
export const v1BusinessProductBasePushEcPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/pushEc`, method: 'post', data })
}
export const v1BusinessProductBaseSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductBaseSaveOrUpdateByAsinPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/saveOrUpdateByAsin`, method: 'post', data })
}
export const v1BusinessProductBaseSaveQueryConditionPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBase/saveQueryCondition`, method: 'post', data })
}
export const v1BusinessProductBrandDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessProductBrand/delete/${id}`, method: 'post', params })
}
export const v1BusinessProductBrandGetListPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBrand/getList`, method: 'post', data })
}
export const v1BusinessProductBrandGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBrand/getListByPage`, method: 'post', data })
}
export const v1BusinessProductBrandSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductBrand/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductProjectManageApprovalPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/approval`, method: 'post', data })
}
export const v1BusinessProductProjectManageAuditPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/audit`, method: 'post', data })
}
export const v1BusinessProductProjectManageBatchDeletePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/batchDelete`, method: 'post', data })
}
export const v1BusinessProductProjectManageDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/delete/${id}`, method: 'post', params })
}
export const v1BusinessProductProjectManageDictConfigUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/dictConfigUpdate`, method: 'post', data })
}
export const v1BusinessProductProjectManageDoNoNeedProductSamplePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/doNoNeedProductSample`, method: 'post', data })
}
export const v1BusinessProductProjectManageFileGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/file/getListByPage`, method: 'post', data })
}
export const v1BusinessProductProjectManageFileSavePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/file/save`, method: 'post', data })
}
export const v1BusinessProductProjectManageFileIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/file/${id}`, method: 'post', params })
}
export const v1BusinessProductProjectManageFileTypeButtonListGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/fileType/buttonList`, method: 'get' })
}
export const v1BusinessProductProjectManageFileTypeGetListPost = () => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/fileType/getList`, method: 'post' })
}
export const v1BusinessProductProjectManageFileTypeGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/fileType/getListByPage`, method: 'post', data })
}
export const v1BusinessProductProjectManageFileTypeSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/fileType/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductProjectManageFileTypeIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/fileType/${id}`, method: 'post', params })
}
export const v1BusinessProductProjectManageGetDicAllListGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/getDicAllList`, method: 'get' })
}
export const v1BusinessProductProjectManageGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/getListByPage`, method: 'post', data })
}
export const v1BusinessProductProjectManageImportProjectPost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/importProject`, method: 'post', data: formData })
}
export const v1BusinessProductProjectManageRefreshEcKdDataGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/refreshEcKdData`, method: 'get' })
}
export const v1BusinessProductProjectManageRefreshQwApprovalGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/refreshQwApproval`, method: 'get' })
}
export const v1BusinessProductProjectManageSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductProjectManage/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductSpuDeletePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductSpu/delete`, method: 'post', data })
}
export const v1BusinessProductSpuGetListPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductSpu/getList`, method: 'post', data })
}
export const v1BusinessProductSpuGetSpuListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductSpu/getSpuListByPage`, method: 'post', data })
}
export const v1BusinessProductSpuSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductSpu/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductStandardPriceDeletePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/delete`, method: 'post', data })
}
export const v1BusinessProductStandardPriceExportProductPlatformPricePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/exportProductPlatformPrice`, method: 'post', data, responseType: 'blob' })
}
export const v1BusinessProductStandardPriceExportProductStandardPricePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/exportProductStandardPrice`, method: 'post', data, responseType: 'blob' })
}
export const v1BusinessProductStandardPriceGetDetailBusinessProductBaseIdPost = (businessProductBaseId, params) => {
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/getDetail/${businessProductBaseId}`, method: 'post', params })
}
export const v1BusinessProductStandardPriceGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/getListByPage`, method: 'post', data })
}
export const v1BusinessProductStandardPriceImportProductPlatformPricePost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/importProductPlatformPrice`, method: 'post', data: formData })
}
export const v1BusinessProductStandardPriceImportProductStandardPricePost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/importProductStandardPrice`, method: 'post', data: formData })
}
export const v1BusinessProductStandardPriceSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductStandardPrice/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductTransferApplicationDetailPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/detail`, method: 'post', data })
}
export const v1BusinessProductTransferApplicationExportExcelPost = data => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/exportExcel`, method: 'post', data })
}
export const v1BusinessProductTransferApplicationGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/getListByPage`, method: 'post', data })
}
export const v1BusinessProductTransferApplicationRefreshMbGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/refreshMb`, method: 'get' })
}
export const v1BusinessProductTransferApplicationRefreshQwApprovalGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/refreshQwApproval`, method: 'get' })
}
export const v1BusinessProductTransferApplicationSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/saveOrUpdate`, method: 'post', data })
}
export const v1BusinessProductTransferApplicationWarehouseListGet = () => {
  return request({ url: `/hhxc-business/v1/businessProductTransferApplication/warehouseList`, method: 'get' })
}
export const v1CockpitCockpitInterfacePost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/CockpitInterface`, method: 'post', data })
}
export const v1CockpitDetailsListPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/DetailsList`, method: 'post', data })
}
export const v1CockpitGetBrandListPost = () => {
  return request({ url: `/hhxc-business/v1/cockpit/getBrandList`, method: 'post' })
}
export const v1CockpitGetCurrentInventoryDetailPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/getCurrentInventoryDetail`, method: 'post', data })
}
export const v1CockpitGetCurrentProgressDetailPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/getCurrentProgressDetail`, method: 'post', data })
}
export const v1CockpitGetMarketListPost = () => {
  return request({ url: `/hhxc-business/v1/cockpit/getMarketList`, method: 'post' })
}
export const v1CockpitGetPlatformListPost = () => {
  return request({ url: `/hhxc-business/v1/cockpit/getPlatformList`, method: 'post' })
}
export const v1CockpitGetProductDevelopmentDataPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/getProductDevelopmentData`, method: 'post', data })
}
export const v1CockpitGetProductFlowDetailPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/getProductFlowDetail`, method: 'post', data })
}
export const v1CockpitGetProductFlowListPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/getProductFlowList`, method: 'post', data })
}
export const v1CockpitMultiQuerysPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/multi-querys`, method: 'post', data })
}
export const v1CockpitSupplyMonitoringPost = data => {
  return request({ url: `/hhxc-business/v1/cockpit/supplyMonitoring`, method: 'post', data })
}
export const v1OaAddSavePost = data => {
  return request({ url: `/hhxc-business/v1/oa/AddSave`, method: 'post', data })
}
export const v1OaDefectAddUpdateSavePost = data => {
  return request({ url: `/hhxc-business/v1/oa/DefectAddUpdateSave`, method: 'post', data })
}
export const v1OaDefectPagePost = data => {
  return request({ url: `/hhxc-business/v1/oa/DefectPage`, method: 'post', data })
}
export const v1OaDevelopmentProgressDefectDetailIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/DevelopmentProgressDefectDetail/${id}`, method: 'post', params })
}
export const v1OaDevelopmentProgressDetailIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/DevelopmentProgressDetail/${id}`, method: 'post', params })
}
export const v1OaDevelopmentProgressListPost = data => {
  return request({ url: `/hhxc-business/v1/oa/DevelopmentProgressList`, method: 'post', data })
}
export const v1OaGetUserClockInDayPost = data => {
  return request({ url: `/hhxc-business/v1/oa/GetUserClockInDay`, method: 'post', data })
}
export const v1OaOaBugDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/OaBugDelete/${id}`, method: 'post', params })
}
export const v1OaOaDevelopmentProgressDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/OaDevelopmentProgressDelete/${id}`, method: 'post', params })
}
export const v1OaOaDictionaryPost = data => {
  return request({ url: `/hhxc-business/v1/oa/OaDictionary`, method: 'post', data })
}
export const v1OaSummaryYearsPost = (years, params) => {
  return request({ url: `/hhxc-business/v1/oa/Summary/${years}`, method: 'post', params })
}
export const v1OaArticleDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/article/delete/${id}`, method: 'post', params })
}
export const v1OaArticleDetailIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/article/detail/${id}`, method: 'post', params })
}
export const v1OaArticleGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/oa/article/getListByPage`, method: 'post', data })
}
export const v1OaArticleSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/oa/article/saveOrUpdate`, method: 'post', data })
}
export const v1OaBannerDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/banner/delete/${id}`, method: 'post', params })
}
export const v1OaBannerGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/oa/banner/getListByPage`, method: 'post', data })
}
export const v1OaBannerSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/oa/banner/saveOrUpdate`, method: 'post', data })
}
export const v1OaCompanyRuleDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/companyRule/delete/${id}`, method: 'post', params })
}
export const v1OaCompanyRuleGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/oa/companyRule/getListByPage`, method: 'post', data })
}
export const v1OaCompanyRuleSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/oa/companyRule/saveOrUpdate`, method: 'post', data })
}
export const v1OaDeleteOaDictionaryIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/deleteOaDictionary/${id}`, method: 'post', params })
}
export const v1OaFindAllReminderPost = data => {
  return request({ url: `/hhxc-business/v1/oa/findAllReminder`, method: 'post', data })
}
export const v1OaFindAllUserMemorandumPost = data => {
  return request({ url: `/hhxc-business/v1/oa/findAllUserMemorandum`, method: 'post', data })
}
export const v1OaGetUserClockInPagePost = data => {
  return request({ url: `/hhxc-business/v1/oa/getUserClockInPage`, method: 'post', data })
}
export const v1OaPerformanceAchievePost = data => {
  return request({ url: `/hhxc-business/v1/oa/performance/achieve`, method: 'post', data })
}
export const v1OaPerformanceReportPost = data => {
  return request({ url: `/hhxc-business/v1/oa/performance/report`, method: 'post', data })
}
export const v1OaSaveOrUpdateOaDictionaryPost = data => {
  return request({ url: `/hhxc-business/v1/oa/saveOrUpdateOaDictionary`, method: 'post', data })
}
export const v1OaSaveReminderPost = data => {
  return request({ url: `/hhxc-business/v1/oa/saveReminder`, method: 'post', data })
}
export const v1OaSaveUserMemorandumPost = data => {
  return request({ url: `/hhxc-business/v1/oa/saveUserMemorandum`, method: 'post', data })
}
export const v1OaStudyExampleDeleteIdPost = (id, params) => {
  return request({ url: `/hhxc-business/v1/oa/studyExample/delete/${id}`, method: 'post', params })
}
export const v1OaStudyExampleGetListByPagePost = data => {
  return request({ url: `/hhxc-business/v1/oa/studyExample/getListByPage`, method: 'post', data })
}
export const v1OaStudyExampleSaveOrUpdatePost = data => {
  return request({ url: `/hhxc-business/v1/oa/studyExample/saveOrUpdate`, method: 'post', data })
}
export const wxApiAddLogisticsGoodsGet = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'get', params })
}
export const wxApiAddLogisticsGoodsHead = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'head', params })
}
export const wxApiAddLogisticsGoodsPost = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'post', params })
}
export const wxApiAddLogisticsGoodsPut = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'put', params })
}
export const wxApiAddLogisticsGoodsDelete = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'delete', params })
}
export const wxApiAddLogisticsGoodsOptions = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'options', params })
}
export const wxApiAddLogisticsGoodsPatch = params => {
  return request({ url: `/hhxc-business/wx-api/addLogisticsGoods`, method: 'patch', params })
}
export const wxApiCheckLogisticsGoodsGet = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'get', params })
}
export const wxApiCheckLogisticsGoodsHead = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'head', params })
}
export const wxApiCheckLogisticsGoodsPost = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'post', params })
}
export const wxApiCheckLogisticsGoodsPut = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'put', params })
}
export const wxApiCheckLogisticsGoodsDelete = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'delete', params })
}
export const wxApiCheckLogisticsGoodsOptions = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'options', params })
}
export const wxApiCheckLogisticsGoodsPatch = params => {
  return request({ url: `/hhxc-business/wx-api/checkLogisticsGoods`, method: 'patch', params })
}
export const wxApiDeliveryGet = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'get', params })
}
export const wxApiDeliveryHead = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'head', params })
}
export const wxApiDeliveryPost = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'post', params })
}
export const wxApiDeliveryPut = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'put', params })
}
export const wxApiDeliveryDelete = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'delete', params })
}
export const wxApiDeliveryOptions = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'options', params })
}
export const wxApiDeliveryPatch = params => {
  return request({ url: `/hhxc-business/wx-api/delivery`, method: 'patch', params })
}
export const wxApiGetFnskuGet = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'get', params })
}
export const wxApiGetFnskuHead = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'head', params })
}
export const wxApiGetFnskuPost = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'post', params })
}
export const wxApiGetFnskuPut = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'put', params })
}
export const wxApiGetFnskuDelete = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'delete', params })
}
export const wxApiGetFnskuOptions = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'options', params })
}
export const wxApiGetFnskuPatch = params => {
  return request({ url: `/hhxc-business/wx-api/getFnsku`, method: 'patch', params })
}
export const wxApiGetInformationGet = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'get', params })
}
export const wxApiGetInformationHead = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'head', params })
}
export const wxApiGetInformationPost = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'post', params })
}
export const wxApiGetInformationPut = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'put', params })
}
export const wxApiGetInformationDelete = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'delete', params })
}
export const wxApiGetInformationOptions = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'options', params })
}
export const wxApiGetInformationPatch = params => {
  return request({ url: `/hhxc-business/wx-api/getInformation`, method: 'patch', params })
}
export const wxApiGetListingGet = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'get', params })
}
export const wxApiGetListingHead = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'head', params })
}
export const wxApiGetListingPost = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'post', params })
}
export const wxApiGetListingPut = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'put', params })
}
export const wxApiGetListingDelete = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'delete', params })
}
export const wxApiGetListingOptions = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'options', params })
}
export const wxApiGetListingPatch = params => {
  return request({ url: `/hhxc-business/wx-api/getListing`, method: 'patch', params })
}
export const wxApiGetLocalStockGet = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'get', params })
}
export const wxApiGetLocalStockHead = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'head', params })
}
export const wxApiGetLocalStockPost = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'post', params })
}
export const wxApiGetLocalStockPut = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'put', params })
}
export const wxApiGetLocalStockDelete = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'delete', params })
}
export const wxApiGetLocalStockOptions = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'options', params })
}
export const wxApiGetLocalStockPatch = params => {
  return request({ url: `/hhxc-business/wx-api/getLocalStock`, method: 'patch', params })
}
export const wxApiGetLocationGet = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'get' })
}
export const wxApiGetLocationHead = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'head' })
}
export const wxApiGetLocationPost = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'post' })
}
export const wxApiGetLocationPut = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'put' })
}
export const wxApiGetLocationDelete = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'delete' })
}
export const wxApiGetLocationOptions = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'options' })
}
export const wxApiGetLocationPatch = () => {
  return request({ url: `/hhxc-business/wx-api/getLocation`, method: 'patch' })
}
export const wxApiGetProductInformationGet = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'get', params })
}
export const wxApiGetProductInformationHead = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'head', params })
}
export const wxApiGetProductInformationPost = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'post', params })
}
export const wxApiGetProductInformationPut = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'put', params })
}
export const wxApiGetProductInformationDelete = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'delete', params })
}
export const wxApiGetProductInformationOptions = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'options', params })
}
export const wxApiGetProductInformationPatch = params => {
  return request({ url: `/hhxc-business/wx-api/getProductInformation`, method: 'patch', params })
}
export const wxApiGetShipmentIdGet = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'get', params })
}
export const wxApiGetShipmentIdHead = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'head', params })
}
export const wxApiGetShipmentIdPost = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'post', params })
}
export const wxApiGetShipmentIdPut = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'put', params })
}
export const wxApiGetShipmentIdDelete = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'delete', params })
}
export const wxApiGetShipmentIdOptions = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'options', params })
}
export const wxApiGetShipmentIdPatch = params => {
  return request({ url: `/hhxc-business/wx-api/getShipmentId`, method: 'patch', params })
}
export const wxApiWarehousingGet = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'get', params })
}
export const wxApiWarehousingHead = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'head', params })
}
export const wxApiWarehousingPost = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'post', params })
}
export const wxApiWarehousingPut = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'put', params })
}
export const wxApiWarehousingDelete = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'delete', params })
}
export const wxApiWarehousingOptions = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'options', params })
}
export const wxApiWarehousingPatch = params => {
  return request({ url: `/hhxc-business/wx-api/warehousing`, method: 'patch', params })
}
export const xyApiGetProductPost = params => {
  return request({ url: `/hhxc-business/xy/api/getProduct`, method: 'post', params })
}
export const xyApiGetShippingRatePost = data => {
  return request({ url: `/hhxc-business/xy/api/getShippingRate`, method: 'post', data })
}
export const xyApiGetWarehousePost = () => {
  return request({ url: `/hhxc-business/xy/api/getWarehouse`, method: 'post' })
}
export const xyApiImportFilePost = data => {
  return request({ url: `/hhxc-business/xy/api/importFile`, method: 'post', data })
}
export const xyApiShippingRateCalcPost = data => {
  return request({ url: `/hhxc-business/xy/api/shippingRate/calc`, method: 'post', data })
}
export const xyApiShippingRateCodePost = () => {
  return request({ url: `/hhxc-business/xy/api/shippingRate/code`, method: 'post' })
}
export const xyApiShippingRateDeletePost = params => {
  return request({ url: `/hhxc-business/xy/api/shippingRate/delete`, method: 'post', params })
}
export const xyApiShippingRateExportPost = data => {
  return request({ url: `/hhxc-business/xy/api/shippingRate/export`, method: 'post', data, responseType: 'blob' })
}
export const xyApiShippingRateImportPost = (data, fileName = 'file', ext = []) => {
  const formData = new FormData()
  if (Array.isArray(data)) {
    data.forEach(item => {
      formData.append(fileName, item)
    })
  } else {
    formData.append(fileName, data)
  }
  if (ext.length) {
    ext.forEach(item => {
      formData.append(item.field, item.value)
    })
  }
  return request({ url: `/hhxc-business/xy/api/shippingRate/import`, method: 'post', data: formData })
}
export const xyApiShippingRateListPost = data => {
  return request({ url: `/hhxc-business/xy/api/shippingRate/list`, method: 'post', data })
}
export const xyApiShippingRateSavePost = data => {
  return request({ url: `/hhxc-business/xy/api/shippingRate/save`, method: 'post', data })
}
